import React from 'react';
import { useTheme as useStyledTheme } from 'styled-components';

import { Icon } from '../icon/icon';

export type PendingTransferIndicatorProps = {
  /** Optional hover tooltip text. */
  title?: string;
  /** Optional inline styles (e.g. margin, fontSize). */
  style?: React.CSSProperties;
};

/**
 * Small indicator icon used when there is a pending project transfer that needs attention.
 * Renders a circle-exclamation icon with optional hover tooltip.
 */
export const PendingTransferIndicator = ({ title, style }: PendingTransferIndicatorProps) => {
  const theme = useStyledTheme();

  return (
    <Icon
      color={theme.color.brand.dark}
      icon={['fas', 'circle-exclamation']}
      style={{ fontSize: '0.75rem', ...style }}
      title={title}
      onHoverStyle={{ color: theme.color.brand.light }}
    />
  );
};
